__turbopack_context__.v({
  "container": "styles-module-scss-module__2J7rZa__container",
  "drawer": "styles-module-scss-module__2J7rZa__drawer",
  "drawer_btn": "styles-module-scss-module__2J7rZa__drawer_btn",
  "drawer_is_open": "styles-module-scss-module__2J7rZa__drawer_is_open",
  "map_container": "styles-module-scss-module__2J7rZa__map_container",
  "map_info_window": "styles-module-scss-module__2J7rZa__map_info_window",
  "map_info_window_additional_info": "styles-module-scss-module__2J7rZa__map_info_window_additional_info",
  "map_info_window_office_name": "styles-module-scss-module__2J7rZa__map_info_window_office_name",
  "map_info_window_price": "styles-module-scss-module__2J7rZa__map_info_window_price",
  "maptype_control": "styles-module-scss-module__2J7rZa__maptype_control",
  "maptype_control_is_active": "styles-module-scss-module__2J7rZa__maptype_control_is_active",
  "maptype_control_map": "styles-module-scss-module__2J7rZa__maptype_control_map",
  "maptype_control_satellite": "styles-module-scss-module__2J7rZa__maptype_control_satellite",
  "property_alert_new_price": "styles-module-scss-module__2J7rZa__property_alert_new_price",
  "property_alert_open_house": "styles-module-scss-module__2J7rZa__property_alert_open_house",
  "property_alert_pending": "styles-module-scss-module__2J7rZa__property_alert_pending",
  "recenter_control": "styles-module-scss-module__2J7rZa__recenter_control",
  "similar_properties_label": "styles-module-scss-module__2J7rZa__similar_properties_label",
  "similar_properties_label_with_alert": "styles-module-scss-module__2J7rZa__similar_properties_label_with_alert",
  "zoom_control": "styles-module-scss-module__2J7rZa__zoom_control",
  "zoom_control_in": "styles-module-scss-module__2J7rZa__zoom_control_in",
  "zoom_control_out": "styles-module-scss-module__2J7rZa__zoom_control_out",
});
